import { render, staticRenderFns } from "./PeerSelector.vue?vue&type=template&id=a981c21c&"
import script from "./PeerSelector.vue?vue&type=script&lang=js&"
export * from "./PeerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports